import { inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { mergeMap, from, map, catchError, of } from 'rxjs';
import { HistoryEntry } from '@models';
import { HistoryEntryService } from '../../services/history-entry.service';

import { HistoryEntriesActions } from './history-entries.actions';

const MAX_SCOPE_ENTRIES = 200;

const historyEntriesIo$ = createEffect(
  (actions$ = inject(Actions), svc = inject(HistoryEntryService)) =>
    actions$.pipe(
      ofType(HistoryEntriesActions.loadScope, HistoryEntriesActions.addEntry),
      mergeMap((action) => {
        if (action.type === HistoryEntriesActions.loadScope.type) {
          const { projectId, scopeKey } = action;
          return from(svc.find({ where: { projectId, scopeKey } as any })).pipe(
            map((res) => {
              const entries = ((res.data ?? []) as HistoryEntry[])
                .sort((a, b) => (b.timestamp ?? 0) - (a.timestamp ?? 0))
                .slice(0, MAX_SCOPE_ENTRIES);
              return HistoryEntriesActions.loadScopeSucceeded({ entries });
            }),
            catchError((e) => of(HistoryEntriesActions.loadScopeFailed({ error: e?.message ?? 'Failed to load history' })))
          );
        }
        return from(svc.save(action.entry)).pipe(
          map((saved) => HistoryEntriesActions.entrySaved({ entry: saved })),
          catchError((e) => of(HistoryEntriesActions.addEntryFailed({ error: e?.message ?? 'Failed to save history entry' })))
        );
      })
    ),
  { functional: true }
);

export const historyEntriesEffects = {
  historyEntriesIo$,
};
